import React from 'react'
import Header from '../../components/shared/Header'
import Footer from '../../components/shared/Footer'
import { useState } from 'react';
import BlogGrid from '../../components/NewLandingPage/blog';
import InterviewsBlogs from './InterviewsBlogs';
import StoriesSection from './StoriesSection';
import { useEffect } from 'react';
function Blogs() {     
    useEffect(()=>{
        window.scrollTo(0, 0);
    
    },[])
    const [searchQuery, setSearchQuery] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('All');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const filterOptions = ['All', 'Carbon Credits', 'Projects', 'Programs', 'Emissions'];
  return (
   <>
   <Header/>
   <section className=' mt-40  ml-64 max-w-auto'>
    <div className=" text-[48px] font-bold">
      <span className=" text-[#0D924F]"> CloseCarbon </span>Blogs, Interviews and Stories
    </div>
    <div className=" text-[16px] text-[#3B3B3B] mt-2">
      Subscribe to stay updated on latest carbon reduction initiatives, sustainable solutions, and environmental innovations.
    </div>
   </section>

   <div className="ml-64 mb-40 mt-40 text-[16px]  h-[56px] left-[120px] top-[348px] flex flex-row justify-between items-center p-0 gap-[274px]">
      {/* Left Section - Filters and Search */}
      <div className="flex flex-row items-start p-0 gap-2 w-[1200px] h-[56px] flex-none order-0 grow-0">
        
        {/* Filter Dropdown Button */}
        <div className="relative">
          <button
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className="flex flex-col justify-center items-center p-8 px-6 gap-2.5 w-full h-[56px] bg-[#F6F6F6] rounded-lg hover:bg-gray-100 transition-colors"
          >
            <div className="flex flex-row justify-center items-center p-3 gap-1 w-[46px] h-6 flex-none order-0 self-stretch grow-0">
              <span className=" font-normal text-[16px] leading-[19px] text-[#006633] p-3">
                {selectedFilter}
              </span>
              <div className="w-10 h-10 relative">
                <svg
                  className="absolute w-4 h-4"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 6L8 10L12 6"
                    stroke="#898989"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
          </button>

          {/* Dropdown Menu */}
          {isDropdownOpen && (
            <div className="absolute top-full left-0 mt-1 w-[120px] bg-white rounded-lg shadow-lg border border-gray-200 z-10">
              {filterOptions.map((option) => (
                <button
                  key={option}
                  onClick={() => {
                    setSelectedFilter(option);
                    setIsDropdownOpen(false);
                  }}
                  className="w-full text-left px-4 py-2  text-sm text-[#141414] hover:bg-[#FAFAFA] hover:text-[#006633] transition-colors first:rounded-t-lg last:rounded-b-lg"
                >
                  {option}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Search Bar */}
        <div className="flex flex-row items-center py-[18px] px-3 gap-10 w-full h-[56px] bg-[#F6F6F6] rounded-2xl">
          <div className="flex flex-row items-end  gap-4 w-full h-5 ">
            {/* Search Icon */}
            <div className="w-5 h-5 relative mr-5 ml-5 mb-3 ">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z" stroke="#B1B1B1" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

         
            </div>
            {/* Search Input */}
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search blog here..."
              className="w-full  font-normal  text-[16px] leading-[19px] text-[#B1B1B1] bg-[#F6F6F6] outline-none focus:text-[#141414]"
            />
          </div>
        </div>
      </div>

      {/* Right Section - Sort By */}
      {/* <div className="flex flex-row items-center p-0 gap-2 w-full h-6 flex-none order-1 grow-0">
        <span className=" font-normal text-[16px] leading-[19px] text-[#141414]">
          Sort By:
        </span>
        <div className="flex flex-row justify-between items-center p-0 w-[100px] h-6">
          <span className=" font-medium text-[16px] leading-[19px] text-[#0D924F]">
            Latest
          </span>
          <button className="w-6 h-6 transform rotate-180">
            <svg
              className="w-6 h-6"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 10L12 15L17 10"
                stroke="#0D924F"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div> */}
    </div>
    <div className='ml-64 mb-20 text-[36px] font-bold'>Blog</div>
    <BlogGrid/>
    <InterviewsBlogs/>
    <StoriesSection/>
   <Footer/>
   </>
  )
}

export default Blogs